import React from 'react';

const Verified = () => {
    return (
                              <span style={{
            display: "inline-flex",
            alignItems: "center",
            backgroundColor: "#e0f7e9",
            color: "#2e7d32",
            fontWeight: "bold",
            fontSize: "12px",
            borderRadius: "12px",
            padding: "4px 8px",
          }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              fill="#2e7d32"
              viewBox="0 0 24 24"
              style={{ marginRight: "4px" }}
            >
              <path d="M20.285 2l-11.285 11.285-5.285-5.285-3.715 3.715 9 9 15-15z" />
            </svg>
            Verified
          </span>
    );
};

export default Verified;